module.exports = __webpack_public_path__ + "saira-medium-webfont.0a406842615620cc0f5b.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-medium-webfont.woff
// module id = ../../../../../src/assets/fonts/saira-medium-webfont.woff
// module chunks = styles